import { createSlice } from "@reduxjs/toolkit";
import {
	editVacationmodeRequest,
	// editVacationmodeRequestput,
	getVacationmodeRequestByID,
	getVacationmodeRequests,
	// getVacationmodeRequestsAddress,
	postVacationmodeRequest,
	vacationActiveAndInactive,
	// postVacationmodeRequestsAddress,
} from "./vactionmodeRequest.action";

const vacationmodeRequestSlice = createSlice({
	name: "vacationmodeRequest",
	initialState: {
		loading: false,
		loadingAddresses: false,
		error: "",
		status: "",
		list: [],
		selectedData: {},
		addressData: {
			default_billing_address: {},
			default_shipping_address: {},
		},
		addressList: [],
		drawer: false,
		openModal: false,
		openUpdateModal: false,
		openAddressModal: false,
		openAddAddressModal: false,
		count: 0,
		addressCount: 0,
		filterParams: {},
		pageParams: {
			start_date: "",
			end_date: "",
			no_of_pages: 0,
			page_size: 10,
			page: 1,
			search: "",
		},
		addressPageParams: {
			start_date: "",
			end_date: "",
			no_of_pages: 0,
			page_size: 10,
			page: 1,
			search: "",
		},
	},
	reducers: {
		isDrawerVisible: (state, action) => {
			return {
				...state,
				drawer: action.payload,
			};
		},
		setOpenModel: (state, action) => {
			return {
				...state,
				openModal: action.payload,
			};
		},
		setUpdateOpenModel: (state, action) => {
			return {
				...state,
				openUpdateModal: action.payload,
			};
		},
		changeParams: (state, action) => {
			return {
				...state,
				pageParams: action.payload,
			};
		},
		setOpenAddressModal: (state, action) => {
			return {
				...state,
				openAddressModal: action.payload,
			};
		},
		setOpenAddAddressModal: (state, action) => {
			return {
				...state,
				openAddAddressModal: action.payload,
			};
		},
		changeAddressParams: (state, action) => {
			return {
				...state,
				addressPageParams: action.payload,
			};
		},
		changeFilterParams: (state, action) => {
			return {
				...state,
				filterParams: action.payload,
			};
		},
		// clearFilterParamsData: (state, action) => {
		// 	return {
		// 		...state,
		// 		filterParams: {},
		// 	};
		// },
		FilterInputChangeValue: (state, action) => {
			return {
				...state,
				filterParams: {
					...state.filterParams,
					[action.payload.key]: action.payload.value,
				},
			};
		},
		setSelectedData: (state, action) => {
			return {
				...state,
				selectedData: action.payload,
			};
		},
		inputChangeValue: (state, action) => {
			console.log(action.payload);
			return {
				...state,
				selectedData: {
					...state.selectedData,
					...action.payload,
				},
			};
		},
		changeShippingAddress: (state, action) => {
			return {
				...state,
				addressData: {
					...state.addressData,
					...action.payload,
				},
			};
		},
		clearShippingAddress: (state, action) => {
			return {
				...state,
				addressData: {},
			};
		},
		clearData: (state, action) => {
			return {
				...state,
				loading: false,
				error: "",
				status: "",
				list: [],
				selectedData: {},
				count: 0,
				pageParams: {
					start_date: "",
					end_date: "",
					no_of_pages: 0,
					page_size: 10,
					page: 1,
					search: "",
				},
			};
		},
	},
	extraReducers: (builder) => {
		builder
			//get Data
			.addCase(getVacationmodeRequests.pending, (state, action) => {
				state.status = "getVacationmodeRequests loading";
				state.loading = true;
			})
			.addCase(getVacationmodeRequests.fulfilled, (state, action) => {
				state.status = "getVacationmodeRequests succeeded";
				state.loading = false;
				var noofpages = Math.ceil(
					action.payload.count / state.pageParams.page_size
				);
				state.count = action.payload.count;
				state.list = action.payload.results;
				state.pageParams = {
					...state.pageParams,
					no_of_pages: noofpages,
				};
			})
			.addCase(getVacationmodeRequests.rejected, (state, action) => {
				state.status = "getVacationmodeRequests failed";
				state.loading = false;
				state.error = action.error.message;
			})
			//get retaailer addresses
			// .addCase(
			// 	getVacationmodeRequestsAddress.pending,
			// 	(state, action) => {
			// 		state.status = "getVacationmodeRequestsAddress loading";
			// 		state.loadingAddresses = true;
			// 	}
			// )
			// .addCase(
			// 	getVacationmodeRequestsAddress.fulfilled,
			// 	(state, action) => {
			// 		state.status = "getVacationmodeRequestsAddress succeeded";
			// 		state.loadingAddresses = false;
			// 		var noofpages = Math.ceil(
			// 			action.payload.count / state.addressPageParams.page_size
			// 		);
			// 		state.addressCount = action.payload.count;
			// 		state.addressList = action.payload.results;
			// 		state.addressPageParams = {
			// 			...state.addressPageParams,
			// 			no_of_pages: noofpages,
			// 		};
			// 	}
			// )
			// .addCase(
			// 	getVacationmodeRequestsAddress.rejected,
			// 	(state, action) => {
			// 		state.status = "getVacationmodeRequestsAddress failed";
			// 		state.loadingAddresses = false;
			// 		state.error = action.error.message;
			// 	}
			// )
			//post retaailer addresses
			// .addCase(
			// 	postVacationmodeRequestsAddress.pending,
			// 	(state, action) => {
			// 		state.status = "postVacationmodeRequestsAddress loading";
			// 		state.loadingAddresses = true;
			// 	}
			// )
			// .addCase(
			// 	postVacationmodeRequestsAddress.fulfilled,
			// 	(state, action) => {
			// 		state.status = "postVacationmodeRequestsAddress succeeded";
			// 		state.loadingAddresses = false;
			// 		state.selectedData = {
			// 			default_billing_address: {},
			// 			default_shipping_address: {},
			// 		};
			// 	}
			// )
			// .addCase(
			// 	postVacationmodeRequestsAddress.rejected,
			// 	(state, action) => {
			// 		state.status = "postVacationmodeRequestsAddress failed";
			// 		state.loadingAddresses = false;
			// 		state.error = action.error.message;
			// 	}
			// )
			//edit retailer
			.addCase(editVacationmodeRequest.pending, (state, action) => {
				state.status = "editVacationmodeRequest loading";
				state.loadingAddresses = true;
			})
			.addCase(editVacationmodeRequest.fulfilled, (state, action) => {
				state.status = "editVacationmodeRequest succeeded";
				state.loadingAddresses = false;
				// state.selectedData = {
				// 	...action.payload.data,
				// 	// salesagent_id: action.payload?.data?.salesagent?.id,
				// 	distributor_id: action.payload?.data?.distributor?.id,
				// 	location_id: action.payload?.data?.location?.id,
				// };
			})
			.addCase(editVacationmodeRequest.rejected, (state, action) => {
				state.status = "editVacationmodeRequest failed";
				state.loadingAddresses = false;
				state.error = action.error.message;
			})
			//edit put retailer
			// .addCase(editVacationmodeRequestput.pending, (state, action) => {
			// 	state.status = "editVacationmodeRequestput loading";
			// 	state.loadingAddresses = true;
			// })
			// .addCase(editVacationmodeRequestput.fulfilled, (state, action) => {
			// 	state.status = "editVacationmodeRequestput succeeded";
			// 	state.loadingAddresses = false;
			// 	state.selectedData = {
			// 		...action.payload,
			// 		salesagent_id: action.payload?.salesagent?.id,
			// 		location_id: action.payload?.location?.id,
			// 	};
			// })
			// .addCase(editVacationmodeRequestput.rejected, (state, action) => {
			// 	state.status = "editVacationmodeRequestput failed";
			// 	state.loadingAddresses = false;
			// 	state.error = action.error.message;
			// })
			//get Data by Id
			.addCase(getVacationmodeRequestByID.pending, (state, action) => {
				state.status = "getVacationmodeRequestByID loading";
				state.loading = true;
			})
			.addCase(getVacationmodeRequestByID.fulfilled, (state, action) => {
				state.status = "getVacationmodeRequestByID succeeded";
				state.loading = false;
				state.selectedData = {
					...action.payload,
					// salesagent_id: action.payload?.salesagent?.id,
					distributor_id: action.payload?.distributor?.id,
					location_id: action.payload?.location?.id,
				};
			})
			.addCase(getVacationmodeRequestByID.rejected, (state, action) => {
				state.status = "getVacationmodeRequestByID failed";
				state.loading = false;
				state.error = action.error.message;
			})
			//post data
			.addCase(postVacationmodeRequest.pending, (state, action) => {
				state.status = "postVacationmodeRequest loading";
				state.loading = true;
			})
			.addCase(postVacationmodeRequest.fulfilled, (state, action) => {
				state.status = "postVacationmodeRequest succeeded";
				state.loading = false;
				state.selectedData = {
					default_billing_address: {},
					default_shipping_address: {},
				};
			})
			.addCase(postVacationmodeRequest.rejected, (state, action) => {
				state.status = "postVacationmodeRequest failed";
				state.loading = false;
				state.error = action.error.message;
			})
			.addCase(vacationActiveAndInactive.pending, (state, action) => {
				state.status = "vacationActiveAndInactive loading";
				state.loading = true;
			})
			.addCase(vacationActiveAndInactive.fulfilled, (state, action) => {
				state.status = "vacationActiveAndInactive succeeded";
				state.loading = false;
			})
			.addCase(vacationActiveAndInactive.rejected, (state, action) => {
				state.status = "vacationActiveAndInactive failed";
				state.loading = false;
				state.error = action.error.message;
			});
	},
});

// Action creators are generated for each case reducer function
export const {
	setOpenAddressModal,
	setOpenAddAddressModal,
	isDrawerVisible,
	changeParams,
	changeFilterParams,
	clearData,
	setSelectedData,
	inputChangeValue,
	setOpenModel,
	setUpdateOpenModel,
	FilterInputChangeValue,
	changeAddressParams,
	changeShippingAddress,
	clearShippingAddress,
} = vacationmodeRequestSlice.actions;

export default vacationmodeRequestSlice.reducer;
